class LoggerConstructor implements Pick<Console, "log" | "warn" | "error"> {
  private readonly enabled = Boolean(import.meta.env.DEV)

  log(...args: unknown[]) {
    if (this.enabled) console.log(...args)
  }

  warn(...args: unknown[]) {
    if (this.enabled) console.warn(...args)
  }

  error(...args: unknown[]) {
    console.error(...args)
  }
}

export const Logger = new LoggerConstructor()
